import { QueryCache, useQuery } from "react-query";
import { ImpactGroup, REACT_QUERY_DEFAULT_STALE_TIME } from "@ecologi/shared";
import { trpc } from "../../../lib/trpc/client";
import { APIError } from "../../../lib";
import { QUERY_KEYS } from "./queryKeys";
import type { AppRouter } from "../../../../../lambdas/api/src/router";
import type { TRPCClient } from "@trpc/client";

export const prefetchImpactGroupsForSSR = async (
  queryCache: QueryCache,
  serverTrpc: TRPCClient<AppRouter>
): Promise<ImpactGroup[]> => {
  await queryCache.prefetchQuery(
    QUERY_KEYS.impactGroups.list,
    (): Promise<ImpactGroup> => serverTrpc.impactGroups.list.query()
  );

  return queryCache.getQueryData(QUERY_KEYS.impactGroups.list) || [];
};

export const useListImpactGroups = (enabled: boolean = true) => {
  return useQuery<ImpactGroup[], APIError>(
    QUERY_KEYS.impactGroups.list,
    () => trpc.impactGroups.list.query(),
    {
      enabled,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: REACT_QUERY_DEFAULT_STALE_TIME,
      onError: (error) => {
        console.error("Failed to load groups:", error);
      },
    }
  );
};
